import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, AbstractControl } from '@angular/forms';
import {MatFormFieldAppearance, MatFormFieldModule} from '@angular/material/form-field';
import {ThemePalette} from '@angular/material/core';
import {SelectOption} from '@xmedical/core';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {ReactiveFormsModule} from '@angular/forms';

@Component({
    selector: 'xui-mat-select',
    templateUrl: './app-mat-select.component.html',
    styleUrls: ['./app-mat-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [MatFormFieldModule, MatSelectModule, MatInputModule, ReactiveFormsModule]
})
export class AppMatSelectComponent {
    readonly appearance = input<MatFormFieldAppearance>('fill');
    readonly color = input<ThemePalette>('primary');
    readonly backgroundColor = input<string | undefined>();
    readonly parentForm = input<UntypedFormGroup | undefined>();
    readonly name = input('');
    readonly label = input('');
    readonly helpText = input('');
    readonly default = input('Please select a value');
    readonly readonly = input(false);
    readonly options = input<SelectOption[]>([]);
    readonly errorMessage = input('');
    readonly valueChanged = output<string | number>();

    private get element(): UntypedFormControl | null {
        const parentForm = this.parentForm();
        const name = this.name();
        if (!parentForm || !name) {
            return null;
        }
        return parentForm.get(name) as UntypedFormControl | null;
    }

    onChange() {
        const element = this.element;
        if (element) {
            this.valueChanged.emit(element.value);
        }
    }

    get fieldValid(): boolean {
        const element = this.element;
        if (!element || !this.required || this.readonly()) { return true; }
        return !element.invalid && (element.dirty || element.touched);
    }

    get required(): boolean {
        const element = this.element;
        const validator = element?.validator ? element.validator({} as AbstractControl) : null;
        return !!(validator && validator.required);
    }

    get invalid(): boolean {
        return this.element?.invalid ?? false;
    }

    get shouldValidate(): boolean {
        const element = this.element;
        return element?.touched || element?.dirty || false;
    }

    get value(): string|number {
      return this.element?.value;
    }

    blur(event: any) {
    }
}

 export interface Option extends SelectOption {

 }
